import { brand } from '../../../current-locale';

const messages = {
  loanTypeConsumer: {
    id: `${brand}.fi.loanTypeConsumer`,
    defaultMessage: 'Consumer',
    description: 'Option of loan types in current loans input',
  },
  loanTypeCar: {
    id: `${brand}.fi.loanTypeCar`,
    defaultMessage: 'Car',
    description: 'Option of loan types in current loans input',
  },
  loanTypeCreditCard: {
    id: `${brand}.fi.loanTypeCreditCard`,
    defaultMessage: 'CreditCard',
    description: 'Option of loan types in current loans input',
  },
  loanTypeMortgage: {
    id: `${brand}.fi.loanTypeMortgage`,
    defaultMessage: 'Mortgage',
    description: 'Option of loan types in current loans input',
  },
  loanTypeStudent: {
    id: `${brand}.fi.loanTypeStudent`,
    defaultMessage: 'Student',
    description: 'Option of loan types in current loans input',
  },
};

const LOAN_TYPES = [
  {
    value: 'car',
    label: messages.loanTypeCar,
  },
  {
    value: 'consumer',
    label: messages.loanTypeConsumer,
  },
  {
    value: 'creditCard',
    label: messages.loanTypeCreditCard,
  },
  {
    value: 'mortgage',
    label: messages.loanTypeMortgage,
  },
  {
    value: 'student',
    label: messages.loanTypeStudent,
  },
];

export default LOAN_TYPES;
